import { render } from "./user.vue?vue&type=template&id=52a66cc8&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=52a66cc8&scoped=true&lang=css"

import exportComponent from "/Users/cindy/mydoc/project/vue-antd-tool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a66cc8"]])

export default __exports__